import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getValuesFromLocalstorage } from "../../../Helpers";
import { useSelector } from "react-redux";

const MenuItem = ({ items }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const userType = getValuesFromLocalstorage("userDetails")?.acctType;
  const appConfigState = useSelector((state) => state.AppConfigReducer);
  const { expandMenuBar } = appConfigState;

  return (
    <div className="flex flex-col space-y-1">
      {items?.map((item) => {
        if (!item?.access?.includes(userType)) return null;
        const isChildItem = item.isChild;

        return (
          <React.Fragment key={item.name}>
            <a
              className={`relative flex items-center py-5 cursor-pointer transition-colors duration-200 
                ${
                  location.pathname === item.href
                    ? "text-primary font-semibold rounded-md"
                    : "hover:text-secondaryBlue text-gray-600"
                }
                ${isChildItem ? (expandMenuBar ? "pl-12" : "pl-5") : "px-5"}`}
              href={item.href}
              onClick={(e) => {
                // Allow browser to handle Ctrl/Cmd/Shift/Right click
                if (
                  e.ctrlKey ||
                  e.metaKey ||
                  e.shiftKey ||
                  e.button !== 0
                ) {
                  return;
                }

                e.preventDefault();
                navigate(item.href);
              }}
            >
              {location.pathname === item.href && (
                <div className="bg-primary h-10 w-1 rounded-2xl absolute left-1" />
              )}
              <div
                className={`min-w-[28px] flex ${
                  expandMenuBar && isChildItem ? "hidden" : "justify-center"
                }`}
              >
                {item.icon && (
                  <item.icon
                    className={`h-7 w-7 ${isChildItem && !expandMenuBar ? "ml-1" : ""}`}
                  />
                )}
              </div>
              {expandMenuBar && <span className="ml-3">{item.name}</span>}
            </a>

            {item?.children &&
              (location.pathname === item.href ||
                item.items.some(
                  (child) => location.pathname === child.href
                )) && <MenuItem items={item.items} />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default MenuItem;
